import leven from 'leven'

export const fuzzyMatch = (testString, searchTerm) => {
  return testString.split(' ').find(word => {
    return leven(word, searchTerm) < 4
  })
}
